module.exports = __webpack_public_path__ + "Icono_TransCX_512.png";